import { render, staticRenderFns } from "./vipDetailSeckillOrders.vue?vue&type=template&id=37a02641&scoped=true"
import script from "./vipDetailSeckillOrders.vue?vue&type=script&lang=js"
export * from "./vipDetailSeckillOrders.vue?vue&type=script&lang=js"
import style0 from "./vipDetailSeckillOrders.vue?vue&type=style&index=0&id=37a02641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a02641",
  null
  
)

export default component.exports